export default {
    install(Vue) {

        Vue.prototype.$formatarDataHoraBR = function(dataUS) {
            return new Date(dataUS).toLocaleString();
        }

        Vue.prototype.$formatarData = function(date) {
            if (!date) return null;
            var result = date
                  .match(/\d{4}-\d{2}-\d{2}/g)
                  .toString()
                  .split("-");
            return result[2] + "/" + result[1] + "/" + result[0];
        }

        Vue.prototype.$parseUSDateToBRDate = function(date) {
            return this.$formatarDataHoraBR( this.$formatDateTime(date) );
        }

        Vue.prototype.$formatDateTime = function(value) {
            return new Intl.DateTimeFormat("pt-BR", {
              dateStyle: "short",
              timeStyle: "short",
              hour12: false,
            }).format(value);
        }

        Vue.prototype.$formatDate = function(value) {
            return new Intl.DateTimeFormat("pt-BR", {
              dateStyle: "short",
              hour12: false,
            }).format(value);
        }

        Vue.prototype.$montarDataHora = function(data, mm, ss) {
            return this.$formatDate(data) + ' ' + (mm + '').padStart(2,'0') + ':' + (ss + '').padStart(2,'0');
        }

    }

}